import {SubCategory} from "@pages/modal/subCategory";

export interface MainCategory {
    catId: number
    catName: string
    activeStatus: string
    maincatImage: string
    createdBy: string
    modifiedBy: string
    createdAt: number
    modifiedAt: number
}

export class MainCategoryClass {
    catId: number
    catName: string
    activeStatus: string
    maincatImage: string
    createdBy: string
    modifiedBy: string
    createdAt: number
    modifiedAt: number
}
